import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { ICoreAuthorizationDTO, ICoreMemberDTO, IDocumentDetailsDTO, IDocumentReferenceProductDTO, IDocumentResponseDTO } from "@app/core/model";
import { DocumentsContextService, DocumentsUploadContextService } from "@app/core/services/context/factory";
import { ShellService } from "@mynexus/mfe-core";
import { ToastMessageOptions } from "primeng/api";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, of } from "rxjs";

@Injectable()
export class SharedDocumentsUploadService implements DocumentsUploadContextService {
  protected readonly API_URL;

  constructor(
    public http: HttpClient,
    protected shellService: ShellService,
    @Inject('stream') private readonly stream: string
  ) {
    this.API_URL = shellService.getBaseUrlFor(stream);
  }

  // each child must override
  getModal(
    dialogService: DialogService,
    authorizationDto: ICoreAuthorizationDTO,
    lineData: object[],
    documents: IDocumentDetailsDTO[],
    memberDto: ICoreMemberDTO,
    message: ToastMessageOptions,
  ): DynamicDialogRef {
    return null;
  }

  levelAdjustmentUpload(selectedDocumentTypes: string[]): void {
    return;
  }

  manageForbiddenDocumentType(
    documents: IDocumentResponseDTO[],
    documentsContextService: DocumentsContextService,
    documentTypes: IDocumentReferenceProductDTO[],
    authorizationStatus: string,
    productName: string,
    manageForbbidenDocumentType: any,
    createContinuedStayRequest: boolean,
  ): Observable<IDocumentReferenceProductDTO[]> {
    return of(documentTypes);
  }

  setSelectionAbility(data: string, selectedTypes: AbstractControl): boolean {
    return false;
  }

  forceContinuedStayRequest(selected: Array<string>, selectedTypes: AbstractControl): boolean {
    return false;
  }

  checkContinuedStayEligibility(authorizationByProductId: string): Observable<ToastMessageOptions> {
    const message: ToastMessageOptions = { severity: 'info' };

    return of(message);
  }
}
